//=====================================================
//　G003カレンダー説明書き
//=====================================================
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { CtxClinicSystemInfo } from "../../utils/Contexts";
import { IFG003Param } from "./G003"

export function G003CalendarNotes(){
    const ccsi = useContext(CtxClinicSystemInfo);  //医院情報
    const params = useParams<IFG003Param>();

    if (params.mode === "monthly"){
        return (
            <div className="calendar-note">
                <ul className="exp-mark calendar-exp-text">
                    <li><span className="icon-circle"></span>：空きあり</li>
                    <li><span className="icon-triangle"></span>：残りわずか</li>
                    {!ccsi.data.display.phoneIcon && <li><span className="icon-cross"></span>：空きなし</li>}
                    {ccsi.data.display.phoneIcon && <li><span className="icon-phone"></span>：お電話にてご相談ください</li>}
                </ul>
                <div className="exp-ampm calendar-exp-text">
                    <span className="exp-ampm-bar"></span>の上が午前、下が午後の空き状況です。
                </div>
            </div>
        )
    } else {
        return (
            <div className="calendar-note">
                <div className="exp-vacant"><span className="icon-circle"></span>&nbsp;が表示されている箇所がご予約可能な日付・時間帯です。</div>
                {/* {ccsi.data.display.phoneIcon && <div className="exp-tel"><span className="icon-phone"></span>&nbsp;マークの日時をご希望の方は、お電話にてお問い合わせください。</div>} */}
            </div>
        )
    }

}